/**
 * Meta Ads enums - SOURCE OF TRUTH
 * Pure TypeScript - no Drizzle imports
 */
// Meta campaign status labels
export const metaCampaignStatusLabels = {
    draft: 'Draft',
    pending: 'Pending',
    active: 'Active',
    paused: 'Paused',
    archived: 'Archived',
    error: 'Error',
};
export const metaCampaignStatusValues = Object.keys(metaCampaignStatusLabels);
// Meta campaign objective labels
export const metaCampaignObjectiveLabels = {
    OUTCOME_AWARENESS: 'Awareness',
    OUTCOME_ENGAGEMENT: 'Engagement',
    OUTCOME_LEADS: 'Leads',
    OUTCOME_SALES: 'Sales',
    OUTCOME_TRAFFIC: 'Traffic',
};
export const metaCampaignObjectiveValues = Object.keys(metaCampaignObjectiveLabels);
// Meta ad status labels
export const metaAdStatusLabels = {
    draft: 'Draft',
    launching: 'Launching',
    pending: 'Pending',
    active: 'Active',
    paused: 'Paused',
    rejected: 'Rejected',
    error: 'Error',
};
export const metaAdStatusValues = Object.keys(metaAdStatusLabels);
// How an ad's service / promotion link was made. `app` = chosen in Borradh
// (ads UI, Claire, or the picker); `creative` = carried over from the ad's
// generated graphic/video; `auto` = inferred by the ad-link matcher from the
// ad's copy and creative. Auto-matching never overwrites an `app` link.
export const adLinkSourceLabels = {
    app: 'Set in Borradh',
    creative: 'From the ad creative',
    auto: 'Matched automatically',
};
export const adLinkSourceValues = Object.keys(adLinkSourceLabels);
// What the ad/promotion check found when it compared an ad's copy and
// creative with the clinic's promotions. `contradicts` = the ad claims an offer
// the promotion data says differently (50% off vs a 17% promotion);
// `out_of_date` = the ad advertises a date or offer that has passed;
// `no_promotion` = the ad claims an offer nothing in Borradh backs;
// `no_offer_claimed` = the ad makes no price, discount or date claim.
export const adPromotionCheckVerdictLabels = {
    consistent: 'Matches the promotion',
    contradicts: 'Contradicts the promotion',
    out_of_date: 'Out of date',
    no_promotion: 'No promotion set up',
    no_offer_claimed: 'No offer in the ad',
};
export const adPromotionCheckVerdictValues = Object.keys(adPromotionCheckVerdictLabels);
// Meta call to action labels
export const metaCallToActionLabels = {
    LEARN_MORE: 'Learn More',
    SHOP_NOW: 'Shop Now',
    SIGN_UP: 'Sign Up',
    CONTACT_US: 'Contact Us',
    WATCH_MORE: 'Watch More',
    BOOK_NOW: 'Book Now',
    GET_QUOTE: 'Get Quote',
    SUBSCRIBE: 'Subscribe',
    DOWNLOAD: 'Download',
    GET_OFFER: 'Get Offer',
    WHATSAPP_MESSAGE: 'Send WhatsApp Message',
};
export const metaCallToActionValues = Object.keys(metaCallToActionLabels);
// Follow-up type labels
export const followUpTypeLabels = {
    sequence: 'Sequence',
    chatbot: 'Chatbot',
    email_only: 'Email Only',
    lead_form: 'Lead Form',
    website: 'Website',
    /** Clicks land on the service's booking funnel (`/start/{serviceId}`). */
    booking_funnel: 'Booking Funnel',
};
export const followUpTypeValues = Object.keys(followUpTypeLabels);
// Ad placement labels
export const adPlacementLabels = {
    facebook: 'Facebook',
    instagram: 'Instagram',
    both: 'Facebook & Instagram',
};
export const adPlacementValues = Object.keys(adPlacementLabels);
// Conversion destination labels (active destinations only)
export const conversionDestinationLabels = {
    messenger: 'Messenger',
    whatsapp: 'WhatsApp',
};
export const conversionDestinationValues = Object.keys(conversionDestinationLabels);
// All conversion destination values including deprecated ones (for DB enum backward compatibility)
export const conversionDestinationAllValues = [
    'messenger',
    'whatsapp',
    'instagram_direct',
];
/**
 * Messaging destinations that can be selected for an ad. A campaign can
 * target any non-empty subset of these; the feature layer resolves the set
 * to Meta's combo `destination_type` at launch time (e.g. all three →
 * `MESSAGING_INSTAGRAM_DIRECT_MESSENGER_WHATSAPP`, `['whatsapp']` →
 * `WHATSAPP`).
 *
 * Non-messaging destinations (website, lead form, phone call) are out of
 * scope for the current project.
 */
export const messagingDestinationLabels = {
    whatsapp: 'WhatsApp',
    messenger: 'Messenger',
    instagram_dm: 'Instagram DM',
};
export const messagingDestinationValues = Object.keys(messagingDestinationLabels);
// Meta integration status labels
export const metaIntegrationStatusLabels = {
    pending_selection: 'Pending Selection',
    configured: 'Configured',
};
// Token status labels (shared by meta_ads_integration and instagram_integration)
export const tokenStatusLabels = {
    valid: 'Valid',
    needs_reconnect: 'Needs Reconnect',
};
export const tokenStatusValues = Object.keys(tokenStatusLabels);
export const metaIntegrationStatusValues = Object.keys(metaIntegrationStatusLabels);
// Meta page platform labels
export const metaPagePlatformLabels = {
    facebook: 'Facebook',
    instagram: 'Instagram',
};
export const metaPagePlatformValues = Object.keys(metaPagePlatformLabels);
// Ad optimiser suggestion lifecycle: a replacement or challenger ad the
// optimiser builds in the background (image, copy, draft) and offers to launch.
export const adOptimizerSuggestionStatusLabels = {
    building: 'Building',
    drafting: 'Writing copy and draft',
    ready: 'Ready to launch',
    launched: 'Launched',
    completed: 'Completed',
    failed: 'Failed',
    expired: 'Expired',
};
export const adOptimizerSuggestionStatusValues = Object.keys(adOptimizerSuggestionStatusLabels);
//# sourceMappingURL=meta-ads.js.map